import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { getDataHoraFormatada } from '../utils/dataUtils';
import { sortData } from '../common/table/sortHelper';
import BrindeEntradaForm from './brindeEntradaForm';

import {
    setModoEntrada,
    initEntrada,
    getEntradas,
    getOpcoes,
    salvarEntrada,
    excluirEntrada
} from './brindeActions';

const colunas = [
    { field: 'datahora_entrada', type: 'date' },
    { field: 'nome_fornecedor', type: 'text' },
    { field: 'nome_brinde', type: 'text' },
    { field: 'quantidade', type: 'number' },
    { field: 'valor_unitario', type: 'number' },
    { field: 'valor_total', type: 'number' }
];

const moeda = (valor, casas = 2) =>
    `R$ ${FormatUtils.formatarValorTela(valor || 0, casas)}`;

const BrindeEntrada = props => {
    const [pesquisa, setPesquisa] = useState('');
    const [sort, setSort] = useState({
        field: 'datahora_entrada',
        direction: 'desc'
    });

    useEffect(() => {
        props.getEntradas();
        props.getOpcoes();
    }, []);

    const abrir = (modo, registro) => {
        props.setModoEntrada(modo, registro);
        props.initEntrada(registro);
    };

    const onSort = field => setSort(anterior => ({
        field,
        direction:
            anterior.field === field && anterior.direction === 'asc'
                ? 'desc'
                : 'asc'
    }));

    const termo = pesquisa.trim().toUpperCase();
    const filtradas = (props.entradas || []).filter(item =>
        !termo || [
            item.nome_fornecedor,
            item.nome_brinde,
            item.nome_usuario_inclusao,
            item.nome_usuario_alteracao
        ].join(' ').toUpperCase().includes(termo)
    );
    const entradas = sortData(filtradas, sort, colunas);
    const podeIncluir = props.getPermissao(
        'brinde_entrada',
        ['INCLUSAO']
    );
    const podeAlterar = props.getPermissao(
        'brinde_entrada',
        ['ALTERACAO']
    );
    const podeExcluir = props.getPermissao(
        'brinde_entrada',
        ['EXCLUSAO']
    );

    return (
        <Content>
            <Aguardando aguardando={props.aguardando} />

            {props.modo === 'cadastro' &&
                <BrindeEntradaForm
                    onSubmit={props.salvarEntrada}
                />}

            {props.modo === 'exclusao' &&
                <BrindeEntradaForm
                    excluir
                    onSubmit={props.excluirEntrada}
                />}

            {props.modo === 'lista' &&
                <ContentCard>
                    <ContentCardHeader>
                        <Row>
                            <InputPesquisa
                                cols='12 6 3 1'
                                label='Pesquisar'
                                minWidth={344}
                                onChange={setPesquisa}
                            />
                            <div style={{ marginTop: 8 }}>
                                {podeIncluir &&
                                    <button
                                        type='button'
                                        className='btn btn-app bg-success'
                                        onClick={() => abrir('cadastro', {})}
                                    >
                                        <i className='fas fa-plus' />
                                        Adicionar
                                    </button>}
                                <button
                                    type='button'
                                    className='btn btn-app bg-primary'
                                    onClick={() => {
                                        props.getEntradas();
                                        props.getOpcoes();
                                    }}
                                >
                                    <i className='fas fa-sync-alt' />
                                    Atualizar
                                </button>
                            </div>
                        </Row>
                    </ContentCardHeader>
                    <ContentCardBody>
                        <Table responsive border alturaFixa striped>
                            <THead>
                                <Tr>
                                    <ThSort
                                        field='datahora_entrada'
                                        label='Data / Hora'
                                        width={150}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_fornecedor'
                                        label='Fornecedor'
                                        width={220}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='nome_brinde'
                                        label='Brinde'
                                        width={200}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='quantidade'
                                        label='Quantidade'
                                        width={110}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='valor_unitario'
                                        label='Valor unitário'
                                        width={130}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <ThSort
                                        field='valor_total'
                                        label='Valor total'
                                        width={125}
                                        sort={sort}
                                        onSort={onSort}
                                    />
                                    <Th sticky alignCenter width={80} />
                                </Tr>
                            </THead>
                            <TBody>
                                {entradas.map(item => (
                                    <Tr key={item.id}>
                                        <Td alignCenter>
                                            {getDataHoraFormatada(
                                                item.datahora_entrada
                                            )}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_fornecedor}
                                        </Td>
                                        <Td alignCenter>
                                            {item.nome_brinde}
                                        </Td>
                                        <Td alignCenter>
                                            {FormatUtils.formatarValorTela(
                                                item.quantidade,
                                                0
                                            )}{' '}
                                            {item.sigla_unidade_medida}
                                        </Td>
                                        <Td alignCenter>
                                            {moeda(item.valor_unitario, 2)}
                                        </Td>
                                        <Td alignCenter>
                                            {moeda(item.valor_total)}
                                        </Td>
                                        <Td alignCenter minWidth={90}>
                                            <ButtonTable
                                                type='warning'
                                                width={32}
                                                small
                                                icon='fas fa-pencil-alt'
                                                visible={podeAlterar}
                                                title='Editar'
                                                event={() =>
                                                    abrir('cadastro', item)
                                                }
                                            />
                                            <ButtonTable
                                                type='danger'
                                                width={32}
                                                small
                                                icon='fas fa-trash-alt'
                                                visible={podeExcluir}
                                                title='Excluir'
                                                event={() =>
                                                    abrir('exclusao', item)
                                                }
                                            />
                                        </Td>
                                    </Tr>
                                ))}
                            </TBody>
                        </Table>
                    </ContentCardBody>
                </ContentCard>}
        </Content>
    );
};

const mapStateToProps = state => ({
    aguardando: state.brinde.aguardando,
    modo: state.brinde.modoEntrada,
    entradas: state.brinde.entradas,
    getPermissao: state.auth.getPermissao
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoEntrada,
    initEntrada,
    getEntradas,
    getOpcoes,
    salvarEntrada,
    excluirEntrada
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrindeEntrada);
